import Commons from '../../../../Services/Common/Common';

/**
 * PPE_BASIC_04 (보호구 기록) 스키마
 * - fields: 화면/그리드에서 사용하는 필드 메타 (camelCase)
 * - mapper: 조회 API payload 매핑 규칙 (PascalCase, 암호화)
 */
export const PPE_BASIC_04_Schema = {
  fields: {
    elCd: { initial: '', label: '기록코드' },
    erCd: { initial: '', label: '보호구코드' },
    equipNm: { initial: '', label: '보호구명' },
    userId: { initial: '', label: '사용자ID' },
    name: { initial: '', label: '사용자명' },
    equipDate: { initial: null, label: '자가 체크 일자' },
    equipYn: { initial: '', label: '체크 유무' },
  },

  mapper: {
    // 보호구 기록 조회
    search1: {
      DepCd: (_, context) =>
        Commons.EncryptAES(context.search?.depCd || '') || '',
      EquipDate: (_, context) =>
        Commons.EncryptAES(
          context.search?.equipDate || context.search?.searchDate || ''
        ) || '',
      Params: (_, context) =>
        Commons.EncryptAES(
          context.search?.params || context.search?.searchText || ''
        ) || '',
    },
  },
};
